import React from 'react';

import { Reveal } from '../../../../components/Reveal/Reveal';
import { SectionHeader } from '../../../../components/SectionHeader/SectionHeader';

import artemovaPhoto from '../../../../assets/authors/Артемова/Артемова О.Р..png';
import pavlyukPhoto from '../../../../assets/authors/Павлюк/Павлюк А.В..png';

import ui from '../../../../styles/ui.module.css';
import st from './Authors.module.css';

const authors = [
  {
    id: 'artemova',
    badge: 'Автор курса',
    name: 'Артемова Олия Рашитовна',
    role: 'Эксперт Центра развития искусственного интеллекта',
    org: 'ФГАУО ВО РНИМУ им. Н.И. Пирогова (Пироговский Университет)',
    photo: artemovaPhoto,
    summary: [
      'Курс по ИИ призван в простой и доступной форме развить навыки и компетенции применения технологий ИИ при проведении диагностических процедур, выявлении заболеваний на ранней стадии и снизить нагрузку на врачей.',
      'Курс разработан по результатам анализа инцидента И11 и учитывает все аспекты внедрения технологий ИИ в здравоохранении для всех участников оказания медицинской помощи.',
    ],
  },
  {
    id: 'pavlyuk',
    badge: 'Автор курса',
    name: 'Павлюк Алексей Владимирович',
    role: 'Директор по цифровой трансформации',
    org: 'ФГАУО ВО РНИМУ им. Н.И. Пирогова (Пироговский Университет)',
    photo: pavlyukPhoto,
    summary: [
      'При разработке курса мы проанализировали проблемы, с которыми регионы, клиники и специалисты сталкиваются при внедрении ИИ, и собрали ответы на вопрос, почему технологии пока не работают на 100%.',
      'В программе собраны факты, лучшие практики внедрения, опыт лидеров отрасли и конкретные шаги, которые помогают видеть в ИИ рабочий инструмент и уверенно внедрять технологии в повседневную практику.',
    ],
  },
];

export function Authors() {
  return (
    <section className={`${ui.section} ${ui.sectionSeam} ${st.root}`}>
      <div className={ui.container}>
        <Reveal>
          <SectionHeader
            kicker="Авторы"
            title="Авторы курса"
            subtitle="Программу создали эксперты, которые разбирают не только возможности ИИ в медицине, но и реальные барьеры его внедрения в клиниках и регионах."
          />
        </Reveal>

        <Reveal delay={0.04}>
          <div className={`${ui.card} ${st.leadCard}`}>
            <div className={st.leadKicker}>Экспертный подход</div>
            <div className={st.leadTitle}>Курс построен на реальной практике внедрения ИИ в здравоохранении</div>
            <div className={st.leadText}>
              Авторы собрали в программе сценарии применения ИИ, ограничения технологий, лучшие практики внедрения и организационные шаги, которые помогают использовать решения в реальной медицинской среде.
            </div>
          </div>
        </Reveal>

        <div className={st.grid}>
          {authors.map((author, index) => (
            <Reveal key={author.id} delay={Math.min(0.08 + index * 0.04, 0.16)}>
              <article className={`${ui.card} ${st.card}`}>
                <div className={st.cardHead}>
                  <div className={st.photoShell}>
                    <div className={st.photoFrame}>
                      <img className={st.photo} src={author.photo} alt={author.name} />
                    </div>
                    <div className={st.photoGlow} aria-hidden="true" />
                  </div>
                  <div className={st.identity}>
                    <div className={st.badge}>{author.badge}</div>
                    <h3 className={st.name}>{author.name}</h3>
                    <div className={st.role}>{author.role}</div>
                    <div className={st.org}>{author.org}</div>
                  </div>
                </div>

                <div className={st.contentColumn}>
                  <div className={st.copy}>
                    {author.summary.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
